import React from "react";
import { lazy } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";
import ErrorPage from "../components/ErrorPage";
import MainLayout from "../layouts/MainLayout";
import Delete from "pages/Delete";

// Lazy Loaded Pages
const Home = lazy(() => import("pages/Home"));
const FAQ = lazy(() => import("pages/FAQ"));
const ContactUs = lazy(() => import("pages/ContactUs"));
const AboutUs = lazy(() => import("pages/AboutUs"));
const Solutions = lazy(() => import("pages/Solutions"));
const PrivacyPolicy = lazy(() => import("pages/PrivacyPolicy"));
const CookiesPolicy = lazy(() => import("pages/CookiesPolicy"));
const TermsAndConditions = lazy(() => import("pages/TermsAndConditions"));

const router = createBrowserRouter([
  {
    path: "",
    errorElement: <ErrorPage />,
    element: (
      <MainLayout>
        <Outlet />
      </MainLayout>
    ),
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "/faq",
        element: <FAQ />,
      },
      {
        path: "/contact-us",
        element: <ContactUs />,
      },
      {
        path: "/about-us",
        element: <AboutUs />,
      },
      {
        path: "/solutions",
        element: <Solutions />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/cookies-policy",
        element: <CookiesPolicy />,
      },
      {
        path: "/terms-conditions",
        element: <TermsAndConditions />,
      },
      {
        path: "/delete",
        element: <Delete />,
      },
    ],
  },
]);

export { router };
